import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { StorageService } from '../shared/storage/storage.service';

@Component({
  selector: 'app-redirect',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex items-center justify-center min-h-screen">
      <div class="text-center">
        <h2 class="text-xl mb-4">Redirection en cours...</h2>
        <p class="text-gray-600">Veuillez patienter pendant que nous vous redirigeons.</p>
      </div>
    </div>
  `
})
export class RedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private storageService: StorageService
  ) {}

ngOnInit() {
  this.route.queryParams.subscribe(queryParams => {
    const { accessToken, refreshToken, organizationId, endImpersonate } = queryParams;
    if (accessToken && refreshToken) {
      this.storageService.setAccessToken(accessToken);
      this.storageService.setRefreshToken(refreshToken);
      
      // Handle end impersonate flow - remove admin refresh token
      if (endImpersonate === 'true') {
        this.storageService.removeAdminRefreshToken();
        this.router.navigate(['/home']);
      } else if (organizationId) {
        this.router.navigate(['/organizations', organizationId]);
      } else {
        this.router.navigate(['/dashboard']);
      }
    } else {
      this.router.navigate(['/auth/login']);
    }
  });
}
}